<template>
  <el-card v-bind:style="style">
    <strong>CONDITIONS GÉNÉRALES</strong>
    <ol>
      <li v-if="payment">
          PRÉAMBULE
          <br> <br>
          Le présent document a pour objet de fixer les conditions de
          vente et d’usage des demandes de résiliation. Le
          présent document vaut conditions générales de vente de notre
          site internet
          <a :href="url">
            {{ site }}
          </a>
          .
          <br> <br>
          Chaque commande sur le site
          <a :href="url">
            {{ site }}
          </a>
          est régie par les présentes conditions générales de vente et d’usage applicables
          à la date de la demande de résiliation, ainsi que par les conditions générales
          d’utilisation du site.
          <br>
          En cochant la case par laquelle il reconnaît avoir pris
          connaissance des conditions générales de vente, de délivrance
          et d’usage, lors de la validation de sa commande, le demandeur
          accepte sans réserves les conditions générales de vente, de
          délivrance et d’usage.
          <br> <br>
          Si toutefois le demandeur ne souhaite pas adhérer à toute ou
          partie des présentes conditions générales, il lui est demandé
          de renoncer à l’utilisation de ce site.
          <br> <br>
        </li>
        <li>
          MENTIONS LEGALES
          <br/>
          Éditeur du Site : Humanistes (RCS Paris 821 295 763)
          <br/>
          Adresse : 89 Av Secretan, Paris (75019), FRANCE
          <br/>
          SIRET : 82129576300014
          <br/>
          TVA : FR 01 821295763
          <br/>
          Téléphone : (33) 09 51 50 04 40
          <br/>
          <a :href="mailto">
            Email : {{ contact }}
          </a>
          <br/>
          Site Web :
          <a :href="url">
            {{ url }}
          </a>
          <br/><br/>
          Hébergeur : <strong>Digital Ocean, Inc</strong> <br>
          Adresse du Siège social : 101 Avenue of the Americas, 10th
          Floor, New York, NY 10013
          <br>
          Adresse de l’hébergement : Amsterdam (Pays-Bas)
          <br></li>
        <li v-if="payment">
          CONTACT
          <br>
          Pour entrer en contact avec nos services, privilégiez notre
          adresse
          <a :href="mailto">
            email : {{ contact }}
          </a>
          . Vous pouvez aussi nous laisser un messsage sur notre
          répondeur au 09 51 50 04 40. Dès lors que vous entrez en
          contact avec nos services, nous vous conseillons d’indiquer
          systématiquement le nom, prénom et l’adresse mail avec lesquels vous avez passés
          commande. Nous vous assurons une réponse rapide, par retour de
          mail, sous 24H/48H.
          <br>
        </li>
        <li v-if="payment">
          TARIFS APPLICABLES
          <br>
          Toute demande de résiliation est facturée 39€99. Ce montant permet de faire la demande express par courrier postal au service résiliation concernée.
          La demande sera faite par courrier recommandé qui sera envoyé à l'adresse demandé dans le formulaire.
          <br> <br>
          Les prix figurant sur le site Internet sont des prix TTC en
          euro tenant compte de la TVA applicable au jour de la commande.
          Tout changement du taux de TVA sera répercuté sur le prix des
          produits ou des services.
          <br> <br>
          Humanistes se réserve le droit de modifier ses prix à tout
          moment, étant toutefois entendu que le prix figurant sur le
          site Internet et les présentes Conditions Générales de Vente le
          jour de la commande sera le seul applicable à l’Acheteur, sauf
          erreur manifeste sur un prix affiché.
          <br> <br>
        </li>
        <li v-if="payment">
          DÉMARCHE DE RESILIATION
          <br> <br>
          Le demandeur complète le formulaire du site dédié à la commande
          de résiliation. Le demandeur recevra, dès
          lors, une validation de sa commande ainsi qu'un suivi de l'expédition de la demande en recommandé. Le paiement de la commande s’effectue
          par un paiement sécurisé par carte bancaire. Les demandes sur ce
          site sont effectuées volontairement et ne pourront être
          obligatoires.
          <br> <br>
          Malgré les soins apportés la SAS Humanistes ne peut pas être
          tenue pour responsable, en cas d’erreur commise par l’Acheteur dans la saisie de ses
          informations pour que la résiliation soit prise en compte.
          <br> <br>
        </li>

        <li v-if="payment">
          DÉLAI DE RÉALISATION DE LA DEMANDE          <br> <br>
          L’utilisateur se verra accepté si les informations fournies sont
          conformes, la demande de résiliation en fonction  des conditions exigées par le service à résilier. Humanistes s'engage à envoyer le recommandé sous 48h. <br> <br>
        </li>
        <li v-if="payment">
          NON-RÉSILIATION DU SERVICE DEMANDÉ
          <br> <br>
          En cas de non résiliation du service demandé, , le
          demandeur est invité à vérifier que l'ensemble des informations demandées ont été correctement renseigné et que les conditions du service permettent sa résiliation. Si l’ensemble des informations fournis sont exactes et à jour, le
          demandeur doit contacter notre site par courrier électronique.
          <br> <br>
        </li>
        <li v-if="payment">
          AIRE GÉOGRAPHIQUE
          <br> <br>
          La vente en ligne de demande de résiliation est réservée aux acheteurs qui résident en France métropolitaine.
          <br> <br>
        </li>
        <li v-if="payment">
          DONNÉES PERSONNELLES
          <br> <br>
          Les registres informatisés, conservés dans les systèmes
          informatiques de
          <a :href="url">
            {{ site }}
          </a>
          ou de ses sous-traitants, dans des conditions raisonnables de
          sécurité, seront considérés comme des preuves de
          communications, des commandes et des paiements intervenus entre
          Le Site et l’Utilisateur.
          <br> <br>
          L’archivage des formulaires d’inscriptions, des bons de
          commandes, des confirmations de commandes et d’inscriptions et
          des factures, est effectué sur un support fiable et durable
          pouvant être produit à titre de preuve. Cet archivage n’a
          aucune durée limitée. Conformément à la loi Informatique et
          Liberté 78-17 du 6 janvier 1978 modifiée, vous disposez d’un
          droit d’opposition (art. 38), d’accès (art. 39), de
          rectification ou de suppression (art. 40) des données qui vous
          concernent. Vous pouvez exercer ce droit en vous adressant au
          site, en justifiant de son identité par courrier électronique à
          l’adresse
          <a :href="mailto">
            {{ contact }}
          </a>
          .
          <br> <br>
          L’Utilisateur reconnaît expressément que toute inscription au
          site, exprimée et complétée par son paiement, vaudra signature
          de ce dernier au même titre que sa signature manuscrite. Le
          site pourra également utiliser les données transmises par
          l’utilisateur afin de contacter l’utilisateur pour n’importe
          quel motif que ce soit. Concernant les données bancaires, le
          site affirme que toutes les saisies relatives au paiement du
          service sont totalement sécurisées par le prestataire Stripe.
          <br> <br>
        </li>
        <li v-if="payment">
          PAIEMENT ET FACTURATION
          <br> <br>
          Le paiement de la commande s’effectue en ligne, à la date de la
          commande, uniquement par carte bancaire, le site étant
          parfaitement sécurisé. La lettre de résiliation sera produit et envoyé
          après paiement de la commande. Une fois la commande validée,
          l’utilisateur recevra à l’adresse électronique saisie lors de
          sa commande. une confirmation par e-mail reprenant le détail de
          sa commande. Vous pouvez demander une facture en vous adressant
          à
          <a :href="mailto">
            {{ contact }}
          </a>
          .
          <br> <br>
          La confirmation de la commande entraîne acceptation des
          présentes conditions de vente, la reconnaissance d'en avoir
          parfaite connaissance et la renonciation à se prévaloir de ses
          propres conditions d'achat ou d'autres conditions. L'ensemble
          des données fournies et la confirmation enregistrée vaudront
          preuve de la transaction. La confirmation vaudra signature et
          acceptation des opérations effectuées.
          <br> <br>
        </li>
        <li v-if="payment">
          ANNULATION, REMBOURSEMENT ET NON RÉTRACTATION
          <br/>
          <br/>
          Le client reconnaît que la commande d'un dossier de demande de résiliation constitue, du fait du choix opéré
          par le client sur l'identité de la personne concernée renseigné, la
          fourniture d'un bien personnalisé au sens de l'article L121-21-8, 3°
          du Code de la consommation.<br>
          Dès lors, le client est expréssement informé qu'il ne peut pas, en
          application de ces dispositions, exercer son droit de rétractation
          sur l'achat d'un service de résiliation en ligne.
          <br/>
          <br/>
        </li>
        <li v-if="payment">
          SAISIES ERRONÉES LORS DE LA COMMANDE
          <br> <br>
          Dès lors que l’utilisateur fait une demande de résiliation  par le biais
          du site et procèdent au paiement, il doit s’assurer que toutes
          les informations transmises sur le formulaire soient conformes.
          Seul l’utilisateur est responsable des informations
          saisies lors de la commande. Le site ne pourra être tenu
          responsable des saisies erronées et ne pourra effectuer aucun
          remboursement. Nous invitons l’utilisateur à être vigilant sur
          ce point. L’utilisateur devra, dès lors, nous communiquer par
          mail les bonnes informations afin que nous refassions le
          nécessaire pour l’envoi de la demande de résiliation par courrier postal. Si
          toutes les informations saisies sont conformes et que la résiliation n'a pas été prise en compte dans les d&lais légaux, l’utilisateur peut nous contacter par mail (
          <a :href="mailto">
            {{ contact }}
          </a>
          ) pour formuler une réclamation. Le site s’engage à se
          rapprocher des services concernés afin de procéder au bon
          acheminement des demandes de résiliation.
          <br> <br>
        </li>
        <li v-if="payment">
          RESPONSABILITÉ
          <br>
          Humanistes, dans le processus de vente en ligne, n'est tenu
          que par une obligation de moyen. Sa responsabilité ne pourra
          être engagée pour un dommage résultant de l'utilisation du
          réseau Internet tel que perte de données, intrusion, virus,
          rupture du service, ou autres problèmes involontaires.
          <br> <br>
        </li>
        <li>
          PROPRIÉTÉ INTELLECTUELLE
          <br>
          Tous les éléments du site
          <a :href="url">
            {{ site }}
          </a>
          sont et restent la propriété intellectuelle et exclusive de la
          SAS Humanistes. Personne n'est autorisé à reproduire,
          exploiter, rediffuser, ou utiliser à quelque titre que ce soit,
          même partiellement, des éléments du site qu'ils soient
          logiciels, visuels ou sonores. Tout lien simple ou par
          hypertexte est strictement interdit sans un accord écrit exprès
          de la SAS Humanistes.
          <br> <br>
        </li>
        <li v-if="payment">
          RÉCLAMATIONS – ATTRIBUTION JURIDICTIONNELLE
          <br> <br>
          Pour toute réclamation relative à la demande de résiliation,
          le demandeur contacte notre site via notre adresse e-mail:
          <a :href="mailto">
            {{ contact }}
          </a>
          . En cas de litige, la loi applicable est la loi française.
          <br> <br>
          Tout litige relatif à la formation, à l’exécution ou à
          l’interprétation des présentes conditions est de la compétence
          exclusive des tribunaux français compétents lorsque le
          demandeur agit hors le cadre de son activité professionnelle.
          <br>
          Tout litige relatif à la formation, à l’exécution ou à
          l’interprétation des présentes conditions est de la compétence
          exclusive du tribunal de commerce de Paris lorsque le demandeur
          agit dans le cadre de son activité professionnelle. Cette
          clause s’applique également en cas de référé, de recours en
          garantie, de demande incidente ou de pluralité de défendeurs et
          quels que soient le mode et les modalités de paiement.
        </li>
      </ol>
  </el-card>
</template>

<script>
export default {
  props: {
    rows: Number,
    contact: String,
    payment: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    mailto () {
      return 'mailto:' + this.contact
    },
    url () {
      return 'https://' + this.site
    },
    site () {
      return window.location.hostname
    },
    style () {
      if (this.rows) {
        return {
          height: this.rows + 'em',
          overflow: 'auto'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .el-card {
    background: #F5F5F5;
  }
</style>



// WEBPACK FOOTER //
// src/components/cgu.vue